var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.5 12.75H6.75V8.25H17.25L16.5 12.75Z","fill":"#1E222D","key":0}),React.createElement("path",{"d":"M9.00007 5.25C9.00007 5.85 9.00007 23.25 9.00007 23.25H13.5001C13.5001 23.25 13.5001 6.375 13.5001 6C13.5001 5.475 13.8001 5.25 14.2501 5.25C15.2251 5.25 16.2751 5.25 17.2501 5.25C17.2501 4.725 17.2501 2.475 17.2501 0.75C15.9751 0.75 14.4751 0.75 13.8001 0.75C8.92506 0.75 9.00007 4.725 9.00007 5.25Z","fill":"#1E222D","key":1})]);
}

FacebookInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
